
import * as React from 'react';
import { HttpRequest } from '../../../util/http';
import { IReport, IResource } from '../interfaces';

interface IReportListingProps {
  onChange: (report) => void
}

interface IReportListingState {
  reportListing: IReport[]
}

export class ReportListing extends React.Component<IReportListingProps, IReportListingState> {

  state: IReportListingState = {
    reportListing: []
  }

  componentWillMount() {
    //NOTE: Make a request to pull available list of reports
    this.fetchReportListing()
  }

  fetchReportListing() {
    const request = { action: 'GetPermission', principal: 'avannis@salem', permissionType: 'REPORT', resourceMask: '' }
    const method = 'POST'
    const body = JSON.stringify(request)
    const params = request
    HttpRequest.fetch<IResource>('scripts/users/get_permissions_bytype', { params, method, body }).then((res) => {
      const listing = res.data
      const reportListing: IReport[] = []
      listing.forEach((element) => {
        const context = JSON.parse(element.context)
        reportListing.push({ key: element.objectKey, name: context.Label, objectkey: context.objectKey, filename: context.filename, filters: context.filters })
      });

      this.setState({ reportListing })
    })
  }

  changeReport(report) {
    if (typeof this.props.onChange === 'function') {
      this.props.onChange(report)
    }
  }

  render() {
    const { reportListing } = this.state
    return (
      <section>
        <span><b><u>Available Reports</u></b></span>
        <ul>
          {reportListing !== null && reportListing.map((report) =>
            <li key={report.key}><a className="link" onClick={(r) => this.changeReport(report)}>{report.name}</a></li>
          )}
        </ul>
      </section>
    )
  }
}
